import { z } from "zod";
import { ofsetsizYerelAn } from "./an-semasi";
import { gerekceSemasi } from "./gerekce";

// F-EXM-22 — yalnız açık boolean kabul edilir; dizgi dönüşümü sıralamayı yanlışlıkla açmamalı.
export const kurumIciSiralamaAyariSemasi = z.object({ acik: z.boolean() }).strict();
export type KurumIciSiralamaAyari = z.infer<typeof kurumIciSiralamaAyariSemasi>;

/** F-EXM-24 — sürüm hazırlıkta alınır; iptalle yarışan DERS_NET yazımı reddedilir. */
export const dersNetGirisiSemasi = z.object({
  ogrenciId: z.string().min(1),
  iptalSurumu: z
    .string({
      required_error: "İptal sürümü gerekli; formu yeniden açın.",
      invalid_type_error: "İptal sürümü geçersiz.",
    })
    .regex(/^[a-f0-9]{64}$/, "İptal sürümü geçersiz; formu yeniden açın."),
  netler: z
    .array(
      z.object({
        sectionId: z.string().min(1),
        dogru: z.number().int().min(0).max(500),
        yanlis: z.number().int().min(0).max(500),
        bos: z.number().int().min(0).max(500),
      }),
    )
    .min(1),
  sureDakika: z.number().int().min(0).max(1440).nullish(),
});
export type DersNetGirisi = z.infer<typeof dersNetGirisiSemasi>;

/**
 * DENEME BÖLÜMÜ — F-EXM-02
 *
 * ================================================================
 * ŞABLON BAŞLANGIÇ NOKTASI, KURAL DEĞİL
 * ================================================================
 * Şartname (satır 848): *"Bölüm yapılandırması: sınav türüne göre
 * şablon (TYT = Türkçe 40, Sosyal 20, Matematik 40, Fen 20).
 * **Düzenlenebilir.**"*
 *
 * Zorunlu olsaydı yayınevinin **38 soruluk Türkçe bölümü** sisteme
 * girilemezdi — ve sonucu görünmez bir kilit olurdu: uzman cevap
 * anahtarını tamamlayamaz, `anahtarTam` hiç `true` olmaz ve **sonuç
 * girişi kalıcı olarak kapalı kalır.**
 *
 * ================================================================
 * SINIRLAR NEDEN BURADA
 * ================================================================
 * 04.09.2026'ya kadar bu şekil yalnızca `deneme.controller.ts`
 * içindeydi. Panel bölüm göndermeye başlayınca aynı sayıları **ikinci
 * kez** yazmak zorunda kaldı ve bunu yazan oturum borcu kendisi
 * bildirdi (`TODO(Faz 6)`).
 *
 * Aynı gün bu sınıfın üç örneği düzeltildi: `ONBOARDING_GUN` sabit
 * vardı ama üretim kodu sayıyı elle yazıyordu · `GEREKCE_EN_AZ`
 * panelde 15, sözleşmede 3'tü · kapsam listesi elle sayılıyordu ve
 * `OWN` eksikti. Dördüncüsünü **oluşmadan** kapatıyoruz.
 *
 * Bir bölümü doğrulayan tek şey bu şema; sunucu da panel de onu
 * kullanıyor.
 */

/** Bölüm adı: boş olamaz, başlık uzunluğunda. */
export const BOLUM_AD_EN_COK = 120;

/**
 * Soru sayısı üst sınırı.
 *
 * 500 keyfi değil: bilinen en uzun oturum (AYT) 160 soru; 500 bir
 * yazım hatasını (4000) yakalarken gerçek bir denemeyi engellemiyor.
 */
export const BOLUM_SORU_EN_COK = 500;

export const denemeBolumSemasi = z.object({
  /**
   * HER KURALIN KENDI TURKCE MESAJI VAR.
   *
   * Mesajsiz bir `.max()` Zod'un varsayilanini uretiyor:
   * "Number must be less than or equal to 500". Bu ekrana CIKIYOR —
   * bagimsiz denetim 04.09.2026'da tam bunu gordu:
   *   "1. bölüm: Number must be less than or equal to 500"
   *
   * CLAUDE.md: "kullaniciya gorunen her metin Turkce."
   *
   * VE BULUNMA BICIMI OGRETICI: kusur semaya yazildigi gun degil,
   * PANEL SEMAYI KULLANMAYA BASLADIGI gun gorundu. Panel kendi
   * mesajlarini yaziyor olsaydi Ingilizce metin hic ekrana cikmaz,
   * kusur semada durur ve kimse bakmazdi. Paylasmak, paylasilan
   * seydeki kusuru da gorunur yapiyor.
   */
  name: z
    .string()
    .trim()
    .min(1, "Bölüm adı boş olamaz.")
    .max(BOLUM_AD_EN_COK, `Bölüm adı en fazla ${BOLUM_AD_EN_COK} karakter olabilir.`),
  questionCount: z
    .number()
    .int("Soru sayısı tam sayı olmalı.")
    .min(1, "Bölümde en az bir soru olmalı.")
    .max(BOLUM_SORU_EN_COK, `Bir bölümde en fazla ${BOLUM_SORU_EN_COK} soru olabilir.`),
  lessonId: z.string().nullish(),
});

export type DenemeBolumu = z.infer<typeof denemeBolumSemasi>;

/**
 * Bölüm listesi — BOŞ GÖNDERİLMEZ, HİÇ GÖNDERİLMEZ.
 *
 * Boş dizi ile "gönderilmedi" ayrı şeyler: birincisi "bu denemenin
 * bölümü yok" demek olurdu ve bölümsüz deneme cevap anahtarı
 * alamazdı. Gönderilmediğinde sunucu şablonu uyguluyor.
 */
export const denemeBolumListesiSemasi = z.array(denemeBolumSemasi).min(1).optional();

// F-EXM-04/05 — yalnız net sonucu boş cevaplara dönüştürmek mevcut sonucu ezer.
export const kendiKodlamamSemasi = z.discriminatedUnion("durum", [
  z.object({ durum: z.literal("GIRILMEMIS") }),
  z.object({
    durum: z.literal("HAM_CEVAPLI"),
    cevaplar: z.record(z.string(), z.string()),
    sureDakika: z.number().nullable(),
  }),
  z.object({ durum: z.literal("YALNIZ_NET") }),
]);

export type KendiKodlamam = z.infer<typeof kendiKodlamamSemasi>;

/**
 * DENEME PENCERE ANI — F-EXM-01a (A3, 05.10.2026)
 *
 * Ofset ZORUNLU ("2026-10-07T06:30:00.000Z" ya da "+03:00"). Ofsetsiz
 * dizgi ("2026-10-07T00:00:00") sunucunun saat diliminde yorumlanir ve
 * UTC calisan uretimde pencereyi 3 saat kaydirir — bkz. `zaman.ts`
 * `yerelAn`. Reddetmek, bu hatanin yeni bir istemciden geri gelmesini
 * derleme degilse bile ilk istekte gorunur yapiyor.
 *
 * ESKI ISTEMCI GECIS ISTISNASI — Codex dagitim denetimi 0510B-05 (05.10.2026):
 * b860250 paneli pencereyi ofsetsiz `${gun}T00:00:00` / `${gun}T23:59:59` gonderiyor.
 * Dagitim istemci dosyalarini degistirir ama ACIK SEKMEYI yenilemez ve panelde "yeni
 * surum var, yenileyin" mekanizmasi yok (olculdu: `BakimBandi` yalniz bakim mesaji, yalniz
 * giris sayfasinda). Bu iki biçim reddedilseydi acik eski sekmede deneme olusturma sayfa
 * yenilenene kadar 400 verirdi. YALNIZ bu iki sabit gun-basi/gun-sonu bicimi kabul ediliyor
 * ve TEK yorum noktasinda (`ofsetsizYerelAn`, F-CAL-09a) Istanbul DUVAR SAATI olarak
 * cozuluyor — eski sunucunun UTC yorumu degil; yani eski sekmeden gelen pencere de dogru
 * ana yaziliyor. Baska ofsetsiz bicim (ornegin "T09:30") yine REDDEDILIR: yeni istemci
 * ofsetli gonderiyor ve kural gevsemiyor.
 * TODO(Faz 2): bir sonraki dagitimda eski sekme kalmadiginda istisna kaldirilabilir.
 */
const ESKI_ISTEMCI_PENCERESI = /^\d{4}-\d{2}-\d{2}T(?:00:00:00|23:59:59)$/;
const ofsetliAn = z.string().datetime({ offset: true });

export const denemeAnSemasi = z.string().transform((s, ctx) => {
  if (ofsetliAn.safeParse(s).success) return new Date(s);
  if (ESKI_ISTEMCI_PENCERESI.test(s)) {
    const an = ofsetsizYerelAn(s);
    if (an && !Number.isNaN(an.getTime())) return an;
  }
  ctx.addIssue({ code: z.ZodIssueCode.custom, message: "Tarih-saat saat dilimiyle gönderilmeli." });
  return z.NEVER;
});

/**
 * ================================================================
 * DENEME HAVUZU VE KARNE — F-EXM-14…25 (TASLAK 01.11.2026, paket C-02)
 * ================================================================
 * Yalnız SÖZLEŞME: uçlar ve kurallar DN paketlerinde. Her kuralın kendi Türkçe mesajı var (yukarıdaki not —
 * Zod varsayılanı ekrana çıkar). Eski denemeler (K-21) bu alanlar olmadan kalır: zorunluluk yalnız YENİ havuz
 * kaydının girdisinde; çıktıda yeni kimlik alanları `nullable`.
 */

/** F-EXM-15 (D2) — havuza girilebilen türler. `ExamKind`teki diğerleri yalnız eski kayıtlarda okunur. */
export const DENEME_HAVUZ_TURLERI = ["LGS", "TYT", "AYT", "YDT"] as const;
export type DenemeHavuzTuru = (typeof DENEME_HAVUZ_TURLERI)[number];

export const denemeHavuzTuruSemasi = z.enum(DENEME_HAVUZ_TURLERI, {
  errorMap: () => ({ message: "Sınav türü LGS, TYT, AYT ya da YDT olmalı." }),
});

/**
 * Eğitim yılı "2026-2027": ardışık iki yıl. Veritabanı yalnız biçimi denetler (CHECK `Exam_egitim_yili_bicimi`);
 * "2026-2028" gibi yazım burada düşer — yıl süzgeci yanlış yazılmış kaydı hiç bulamazdı.
 */
export const egitimYiliSemasi = z
  .string({
    required_error: "Eğitim yılı girilmeli.",
    invalid_type_error: "Eğitim yılı metin olmalı.",
  })
  .trim()
  .regex(/^\d{4}-\d{4}$/, "Eğitim yılı 2026-2027 biçiminde olmalı.")
  .refine((s) => Number(s.slice(5)) === Number(s.slice(0, 4)) + 1, {
    message: "Eğitim yılının ikinci yılı ilkinden bir fazla olmalı.",
  });

/** Dönem 1 ya da 2 (CHECK `Exam_donem_araligi`). */
export const donemSemasi = z
  .number({ invalid_type_error: "Dönem sayı olmalı.", required_error: "Dönem seçilmeli." })
  .int("Dönem tam sayı olmalı.")
  .refine((d) => d === 1 || d === 2, { message: "Dönem 1 ya da 2 olmalı." });

export const SERI_ADI_EN_COK = 120;

export const seriAdiSemasi = z
  .string({ required_error: "Seri adı girilmeli." })
  .trim()
  .min(1, "Seri adı boş olamaz.")
  .max(SERI_ADI_EN_COK, `Seri adı en fazla ${SERI_ADI_EN_COK} karakter olabilir.`);

/** Kimlik alanı (bölüm, yayınevi, konu): boş olamaz. */
const kimlikSemasi = (mesaj: string) =>
  z.string({ required_error: mesaj, invalid_type_error: mesaj }).trim().min(1, mesaj);

/**
 * F-EXM-14/15 — havuz kaydının KİMLİK alanları. Mevcut tanım gövdesiyle (ad, pencere, bölümler, kitapçık
 * bağlantısı) birleştirilir. Yayınevi LİSTEDEN kimlikle seçilir; listede olmayan kimlik servis kararıdır (400) —
 * liste veritabanında, sözleşme göremez. Tek kitapçık (D4): kitapçık türü alanı YOK.
 */
export const denemeKimlikSemasi = z.object({
  kind: denemeHavuzTuruSemasi,
  academicYear: egitimYiliSemasi,
  term: donemSemasi,
  publisherId: kimlikSemasi("Yayınevi seçilmeli."),
  seriesName: seriAdiSemasi,
});
export type DenemeKimlik = z.infer<typeof denemeKimlikSemasi>;

/** F-EXM-15 — yönetimin dört alanla süzmesi. Sorgu dizgisinden geldiği için dönem `coerce`; hepsi isteğe bağlı. */
export const denemeHavuzSuzgeciSemasi = z.object({
  academicYear: egitimYiliSemasi.optional(),
  term: z.coerce
    .number({ invalid_type_error: "Dönem sayı olmalı." })
    .int("Dönem tam sayı olmalı.")
    .refine((d) => d === 1 || d === 2, { message: "Dönem 1 ya da 2 olmalı." })
    .optional(),
  publisherId: kimlikSemasi("Yayınevi seçilmeli.").optional(),
  seriesName: z.string().trim().min(1, "Seri adı boş olamaz.").optional(),
});

/** F-EXM-15 — yayınevi listesi (yönetim tutar; kesin liste müşteriden, §9 madde 23). */
export const YAYINEVI_AD_EN_COK = 120;
export const yayineviSemasi = z.object({
  name: z
    .string({ required_error: "Yayınevi adı girilmeli." })
    .trim()
    .min(1, "Yayınevi adı boş olamaz.")
    .max(YAYINEVI_AD_EN_COK, `Yayınevi adı en fazla ${YAYINEVI_AD_EN_COK} karakter olabilir.`),
});

const soruNoSemasi = z
  .number({
    invalid_type_error: "Soru numarası sayı olmalı.",
    required_error: "Soru numarası girilmeli.",
  })
  .int("Soru numarası tam sayı olmalı.")
  .min(1, "Soru numarası en az 1 olmalı.")
  .max(BOLUM_SORU_EN_COK, `Soru numarası en fazla ${BOLUM_SORU_EN_COK} olabilir.`);

/**
 * F-EXM-16 — kazanım listesi. Tümü-ya-hiç: tek hatalı satır bütün yüklemeyi düşürür; ön izleme (`onIzleme`,
 * varsayılan AÇIK — yanlışlıkla yazmak yerine yanlışlıkla yalnız bakmak) hiçbir şey yazmaz. Bölüm soru sayısıyla
 * karşılaştırma (40 soruluk bölüme 41. satır) veritabanı ister: o kontrol servisin (DN paketi).
 */
export const KAZANIM_EN_COK = 500;
export const KAZANIM_SATIR_EN_COK = 2000;

export const kazanimSatiriSemasi = z.object({
  sectionId: kimlikSemasi("Bölüm seçilmeli."),
  questionNo: soruNoSemasi,
  outcome: z
    .string({ required_error: "Kazanım girilmeli.", invalid_type_error: "Kazanım metin olmalı." })
    .trim()
    .min(1, "Kazanım boş olamaz.")
    .max(KAZANIM_EN_COK, `Kazanım en fazla ${KAZANIM_EN_COK} karakter olabilir.`),
  topicId: z.string().nullish(),
});

export const kazanimListesiYuklemeSemasi = z
  .object({
    satirlar: z
      .array(kazanimSatiriSemasi)
      .min(1, "Kazanım listesi boş olamaz.")
      .max(KAZANIM_SATIR_EN_COK, `Tek yüklemede en fazla ${KAZANIM_SATIR_EN_COK} satır olabilir.`),
    onIzleme: z.boolean().default(true),
  })
  .superRefine((g, ctx) => {
    // Aynı soruya iki kazanım: hangisinin yazılacağı sıraya kalırdı — sessizce sonuncusu kazanmasın.
    const gorulen = new Set<string>();
    g.satirlar.forEach((s, i) => {
      const anahtar = `${s.sectionId}#${s.questionNo}`;
      if (gorulen.has(anahtar)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["satirlar", i, "questionNo"],
          message: `${s.questionNo}. soru listede birden çok kez var.`,
        });
      }
      gorulen.add(anahtar);
    });
  });
export type KazanimListesiYukleme = z.infer<typeof kazanimListesiYuklemeSemasi>;

/** F-EXM-18 — gönderim kilidini "düzeltmeye aç": gerekçe zorunlu (denetime yazılır). */
export const cevapKilidiAcSemasi = z.object({ gerekce: gerekceSemasi() });

/**
 * F-EXM-19 — kaçırana kişisel bitiş. Ofsetli an (`denemeAnSemasi`); "şu andan sonra mı" kararı sunucu saatiyle
 * ve satır kilidi altında verilir (F-EXM-01b) — sözleşme saati göremez.
 */
export const girisYenidenAcSemasi = z.object({
  kisiselBitis: denemeAnSemasi,
  gerekce: gerekceSemasi(),
});

/** Cevap seçeneği — mevcut anahtarla aynı küme (`ExamQuestion.correctAnswer` A|B|C|D|E). */
export const cevapSecenegiSemasi = z.enum(["A", "B", "C", "D", "E"], {
  errorMap: () => ({ message: "Cevap A, B, C, D ya da E olmalı." }),
});

/**
 * F-EXM-23/24 — anahtar düzeltmesi ve soru iptali TEK gövde: ikisi de bütün sonuçları aynı transaction'da yeniden
 * hesaplatır. `onay: false` (varsayılan) ön izlemedir: kaç sonucun neti değişir, hiçbir şey yazılmaz. Sudo ve
 * ALL kapsam kontrolü sunucuda (izin koduyla, F-EXM-24).
 */
export const anahtarDuzeltmeSemasi = z.object({
  degisiklikler: z
    .array(
      z
        .object({
          sectionId: kimlikSemasi("Bölüm seçilmeli."),
          questionNo: soruNoSemasi,
          yeniCevap: cevapSecenegiSemasi.optional(),
          iptal: z.boolean().optional(),
        })
        .refine((d) => d.yeniCevap !== undefined || d.iptal !== undefined, {
          message: "Her satırda yeni cevap ya da iptal bilgisi olmalı.",
        }),
    )
    .min(1, "En az bir soru değişikliği gönderilmeli.")
    .max(BOLUM_SORU_EN_COK, `Tek düzeltmede en fazla ${BOLUM_SORU_EN_COK} soru değişebilir.`),
  gerekce: gerekceSemasi(),
  onay: z.boolean().default(false),
});
export type AnahtarDuzeltme = z.infer<typeof anahtarDuzeltmeSemasi>;

export const anahtarDuzeltmeOnIzlemeSemasi = z.object({
  etkilenenSonuc: z.number().int().min(0),
  netiDegisecek: z.number().int().min(0),
});

/** F-EXM-20 ilk aşama — ders bazlı D/Y/B/net (gönderim anında açık). */
export const denemeDersSatiriSemasi = z.object({
  sectionId: z.string(),
  ad: z.string(),
  dogru: z.number().int(),
  yanlis: z.number().int(),
  bos: z.number().int(),
  net: z.number(),
});

/** F-EXM-20 ikinci aşama — soru soru tablo; yalnız F-EXM-12/19 koşulunda. */
export const denemeSoruSatiriSemasi = z.object({
  sectionId: z.string(),
  questionNo: z.number().int(),
  cevap: z.string().nullable(),
  dogruCevap: z.string(),
  sonuc: z.enum(["DOGRU", "YANLIS", "BOS", "IPTAL"]),
});

/** F-EXM-16/25 — kazanım analizi satırı (liste yüklüyse). */
export const denemeKazanimSatiriSemasi = z.object({
  outcome: z.string(),
  dogru: z.number().int(),
  toplam: z.number().int(),
});

/**
 * F-EXM-20/21/22/25 — sonuç (karne) çıktısı; öğrenci, veli ve personel aynı şekli alır.
 *
 * İSTEĞE BAĞLI ALAN "boş" DEĞİL "YOK" demek: `sorular` pencere/gönderim koşulu sağlanmadan; `rank` ve
 * `percentile` SELF/LINKED okumada ayar kapalıyken yanıtta HİÇ yer almaz (F-EXM-22: "ekranda gizlemek yetmez").
 * `kazanimlar` liste yüklü değilse yok ("0" gösterilmez, F-EXM-16). `.strict()`: servis ilk aşama yanıtına
 * yanlışlıkla `dogruCevap` gibi tanımsız bir alan koyarsa çıktı doğrulaması düşer — sızıntı sessiz geçmez.
 */
export const denemeSonucCiktisiSemasi = z
  .object({
    examId: z.string(),
    ad: z.string(),
    yayinevi: z.string().nullable(),
    seriesName: z.string().nullable(),
    examDate: z.string(),
    toplamDogru: z.number().int(),
    toplamYanlis: z.number().int(),
    toplamBos: z.number().int(),
    toplamNet: z.number(),
    dersler: z.array(denemeDersSatiriSemasi),
    kilitli: z.boolean(),
    // F-EXM-24 — saklanan alan değildir; iptal ve son giriş tarihinden türetilir.
    duzeltmeBekliyor: z.literal(true).optional(),
    sorular: z.array(denemeSoruSatiriSemasi).optional(),
    kazanimlar: z.array(denemeKazanimSatiriSemasi).optional(),
    rank: z.number().int().optional(),
    percentile: z.number().optional(),
  })
  .strict();
export type DenemeSonucCiktisi = z.infer<typeof denemeSonucCiktisiSemasi>;
